import React from 'react'
import FormField, { FormFieldProps } from './FormField'
import { TimePicker, Typography, useColorMode } from '@airbus/components-react/components'
import { TimePickerProps } from '@airbus/components-react/components/TimePicker'
import FormControl from './FormControl'
import { FormControlProps } from '@airbus/components-react/components/Form'
import { useTranslation } from 'react-i18next'

type CustomTimePickerProps = TimePickerProps & FormControlProps
export const CustomTimePicker = ({
  label,
  error,
  readOnly = false,
  value,
  onChange,
  labelAdornment,
  required = false,
  style,
  ...rest
}: CustomTimePickerProps) => {
  const theme = useColorMode()
  const { t } = useTranslation()

  return (
    <FormControl
      label={label}
      error={error}
      labelAdornment={labelAdornment}
      readOnly={readOnly}
      required={required}
      style={style}
    >
      {readOnly ? (
        <Typography
          style={{
            fontWeight: 'bold',
            lineHeight: theme.size.spacing[40],
            overflowX: 'auto',
          }}
        >
          {value || '-'}
        </Typography>
      ) : (
        // TODO EHA changer partout pour que ça stocke HH:mm dans RHF
        <TimePicker
          value={value || ' '}
          onChange={onChange}
          {...rest}
          inputProps={{
            tabIndex: 0,
            onInvalid: (e: React.FormEvent<HTMLInputElement>) => {
              e.currentTarget.setCustomValidity(t('invalid_format'))
            },
            onInput: (e: React.FormEvent<HTMLInputElement>) => e.currentTarget.setCustomValidity(''),
          }}
        />
      )}
    </FormControl>
  )
}

export const FormTime = (props: FormFieldProps<CustomTimePickerProps>) => (
  <FormField {...props} Component={CustomTimePicker} />
)

export default FormTime
